import { call, put, takeEvery } from 'redux-saga/effects'
import * as menuActions from '../ducks/menuDucks'
import * as menuApi from '../../api/menuApi'

interface FetchSaga {
  type: string
  payload: string
}

function* fetchListMenu({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof menuApi.getListMenu> = yield call(menuApi.getListMenu, queryString)
    yield put(menuActions.getListMenuSuccess(res))
  } catch (error) {
    yield put(menuActions.getListMenuFail(error))
  }
}

function* fetchListOptionMenu({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof menuApi.getListOptionMenu> = yield call(menuApi.getListOptionMenu, queryString)
    yield put(menuActions.getListOptionMenuSuccess(res))
  } catch (error) {
    yield put(menuActions.getListOptionMenuFail(error))
  }
}

function* fetchDetailMenu({ payload: id }: FetchSaga) {
  try {
    const res: ReturnType<typeof menuApi.getDetailMenu> = yield call(menuApi.getDetailMenu, id)
    yield put(menuActions.getDetailMenuSuccess(res))
  } catch (error) {
    yield put(menuActions.getDetailMenuFail(error))
  }
}


export default function* watchMenu() {
  yield takeEvery(menuActions.getListMenu.toString(), fetchListMenu)
  yield takeEvery(menuActions.getListOptionMenu.toString(), fetchListOptionMenu)
  yield takeEvery(menuActions.getDetailMenu.toString(), fetchDetailMenu)
}
